import { WarehouseActionLine } from '@common/models/warehouseActionLine/warehouseActionLine'
import { coreStore } from '@core/store/coreStore'
import { ApiStore } from '@core/api/apiStore'

export class WarehouseActionLineStore extends ApiStore<WarehouseActionLine> {
  constructor() {
    super(coreStore.paramAppStore.apiUrl, '/warehouse-action-line', WarehouseActionLine, 'female', 'Ligne', 'itemName', 'Cette ligne', null)
  }
}
